import { render, staticRenderFns } from "./VirtualShopTableBody.vue?vue&type=template&id=4c39d892&scoped=true"
import script from "./VirtualShopTableBody.vue?vue&type=script&lang=ts"
export * from "./VirtualShopTableBody.vue?vue&type=script&lang=ts"
import style0 from "./VirtualShopTableBody.vue?vue&type=style&index=0&id=4c39d892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c39d892",
  null
  
)

export default component.exports